import { render, staticRenderFns } from "./PaymentFlowAnimation.vue?vue&type=template&id=3163761e&scoped=true&"
import script from "./PaymentFlowAnimation.vue?vue&type=script&lang=js&"
export * from "./PaymentFlowAnimation.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFlowAnimation.vue?vue&type=style&index=0&id=3163761e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3163761e",
  null
  
)

export default component.exports